import User from '@/views/user/User.vue'
import Customer from '@/views/user/Customer.vue'
import Detail from '@/views/user/Detail.vue'
import Help from '@/views/help/Help.vue'

export default [
    {
        // 用户页面
        path: '/user',
        name: 'User',
        component: User,
        meta: {
            requireAuth: true,
        }
    },
    {
        // 我的报备列表
        path: '/customer',
        name: 'Customer',
        component: Customer,
        meta: {
            requireAuth: true,
        }
    },
    {
        // 我的报备显示详情
        path: '/user/reportdetail/:id',
        name: 'UserDetail',
        component: Detail,
        meta: {
            requireAuth: true,
        }
    },
    {
        // 帮助中心
        path: '/user/help',
        name: 'Help',
        component: Help,
        meta: {
            requireAuth: false,
        }
    }
]
